<template>
    <div style="width: 100%">
        <approval-table></approval-table>
    </div>
</template>

<script>
const approvalTable = () =>
    import("@/components/orgApps/Approval/ApprovalTable");

export default {
    name: "dashboard",
    components: {
        approvalTable
    }
};
</script>

<style>
.v-chip.white-span span {
    color: white !important;
}
</style>